import styled from 'styled-components';

export const StyledIFrame = styled.iframe`
  width: 100%;
  height: 100%;
  background-color: white;
  border: none;
`;
